import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63af18ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "placeholder-blocked__header" }
const _hoisted_2 = { class: "flex items-start gap-4" }
const _hoisted_3 = {
  class: "placeholder-blocked__alert-icon",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  viewBox: "0 0 24 24",
  width: "24",
  height: "24"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = { class: "flex flex-col gap-2 min-w-0" }
const _hoisted_7 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_8 = {
  key: 0,
  class: "placeholder-blocked__doctor-chip",
  "data-testid": "placeholder-blocked-subtitle"
}
const _hoisted_9 = {
  viewBox: "0 0 24 24",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = { class: "truncate" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "placeholder-blocked__new-badge",
  "data-testid": "placeholder-blocked-new-badge"
}, " Novo ", -1))
const _hoisted_13 = { class: "placeholder-blocked__scroll" }
const _hoisted_14 = { class: "placeholder-blocked__intro" }
const _hoisted_15 = {
  class: "placeholder-blocked__explanation",
  "data-testid": "placeholder-blocked-explanation"
}
const _hoisted_16 = { class: "placeholder-blocked__body" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "placeholder-blocked__section-title" }, "Como registrar agora", -1))
const _hoisted_18 = {
  class: "placeholder-blocked__steps",
  "data-testid": "placeholder-blocked-steps"
}
const _hoisted_19 = {
  class: "placeholder-blocked__number",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "flex flex-col gap-3 min-w-0" }
const _hoisted_21 = ["data-testid"]
const _hoisted_22 = ["aria-label", "data-testid"]
const _hoisted_23 = {
  inert: "",
  "aria-hidden": "true",
  class: "pointer-events-none select-none"
}
const _hoisted_24 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_25 = { class: "placeholder-blocked__field placeholder-blocked__field--focused" }
const _hoisted_26 = { class: "placeholder-blocked__field-label" }
const _hoisted_27 = { class: "flex items-center justify-between gap-2" }
const _hoisted_28 = {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  class: "shrink-0 text-[#68688D]"
}
const _hoisted_29 = ["d"]
const _hoisted_30 = { class: "placeholder-blocked__menu" }
const _hoisted_31 = {
  key: 2,
  class: "placeholder-blocked__field"
}
const _hoisted_32 = { class: "placeholder-blocked__field-label" }
const _hoisted_33 = {
  key: 3,
  class: "placeholder-blocked__card"
}
const _hoisted_34 = {
  class: "placeholder-blocked__help",
  "data-testid": "placeholder-blocked-help"
}
const _hoisted_35 = {
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  class: "placeholder-blocked__help-icon",
  "aria-hidden": "true"
}
const _hoisted_36 = ["d"]
const _hoisted_37 = { class: "flex flex-col gap-2 min-w-0" }
const _hoisted_38 = { "data-testid": "placeholder-blocked-help-flag" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { "data-testid": "placeholder-blocked-help-management" }, " Se a Dra. Ana vai mesmo fazer este plantão, fale com a gestão de escalas. ", -1))
const _hoisted_40 = { class: "placeholder-blocked__footer" }
const _hoisted_41 = {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  class: "mr-2 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_42 = ["d"]

import { ref, watch } from 'vue'
import {
  mdiAccountOutline,
  mdiAlertOutline,
  mdiCheckCircleOutline,
  mdiInformationOutline,
  mdiMenuUp
} from '@mdi/js'
import CoverageModeSelector from '@/components/Coverage/CoverageModeSelector.vue'
import UnidentifiedRow from '@/components/designSystem/Table/StandardRow/unidentified.vue'
import { UNIDENTIFIED_COVERAGE_COLORS as COLORS } from '@/components/designSystem/Table/StandardRow/unidentifiedCoverageStyles'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { CoverageMode } from '@/Network/Types/Requests/CoverageRequests'
import { DESKTOP_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery'
import {
  COVERAGE_NOTE_LABEL,
  COVERAGE_RESPONSIBLE_LABEL,
  UNIDENTIFIED_COVERAGE_LABEL
} from '@/utils/coverage'

/**
 * Aviso descritivo do `PLACEHOLDER_DOCTOR_BLOCKED`: explica por que o médico "coringa"
 * foi recusado e ensina, com miniaturas dos próprios componentes, a usar
 * "Ocupado sem identificação". Estado via `usePlaceholderDoctorBlocked`.
 */
const COVERAGE_BLOCK_TITLE = 'Cobertura do plantão'
const EXAMPLE_RESPONSIBLE = 'Equipe CLT da Unidade'
// Responsáveis reais do seed do backend, na mesma ordem
const EXAMPLE_NOTE = 'Escala enviada pela unidade até dia 25'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaceholderDoctorBlockedModal',
  props: {
    modelValue: { type: Boolean },
    doctorName: { default: null },
    allowUnidentified: { type: Boolean }
  },
  emits: ["update:modelValue", "useUnidentified", "close"],
  setup(__props: any, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "48672168": (_unref(text))
}))





const EXAMPLE_RESPONSIBLE_OPTIONS = [
  EXAMPLE_RESPONSIBLE,
  'Servidor público da Unidade',
  'Outra empresa / cooperativa',
  'Parceiro indicará (a identificar)'
]
const steps = [
  {
    number: 1,
    text: `Em "${COVERAGE_BLOCK_TITLE}", escolha "${UNIDENTIFIED_COVERAGE_LABEL}"`,
    illustrationLabel: `Seletor "${COVERAGE_BLOCK_TITLE}" com a opção "${UNIDENTIFIED_COVERAGE_LABEL}" marcada`
  },
  {
    number: 2,
    text: `Em "${COVERAGE_RESPONSIBLE_LABEL}", escolha quem cobre, ex. "${EXAMPLE_RESPONSIBLE}"`,
    illustrationLabel: `Campo "${COVERAGE_RESPONSIBLE_LABEL}" com a lista aberta e "${EXAMPLE_RESPONSIBLE}" escolhido`
  },
  {
    number: 3,
    text: `Se quiser, escreva uma observação (ex.: "${EXAMPLE_NOTE}")`,
    illustrationLabel: `Campo de observação preenchido com "${EXAMPLE_NOTE}"`
  },
  {
    number: 4,
    text: 'Salve: o plantão aparece na grade com o card cinza listrado "Ocupado · s/ identificação"',
    illustrationLabel: `Card cinza listrado "Ocupado · s/ identificação" com a etiqueta "${EXAMPLE_RESPONSIBLE}"`
  }
] as const

// id único por instância (Vue 3.3 não tem `useId`; um 2º <script> quebra o ts checker do build)
const titleId = `placeholder-blocked-title-${Math.random().toString(36).slice(2, 10)}`
const titleRef = ref<HTMLElement | null>(null)
const isDesktop = useMediaQuery(DESKTOP_MEDIA_QUERY)

// Foco inicial no título. O VDialog (3.3) foca o próprio conteúdo num `nextTick` ao abrir
// e não emite `afterEnter`; o `setTimeout` (macrotask) roda depois disso.
watch(
  () => props.modelValue,
  (open) => {
    if (!open) return
    setTimeout(() => titleRef.value?.focus({ preventScroll: true }), 0)
  },
  { immediate: true }
)

function closeDialog() {
  emit('update:modelValue', false)
  emit('close')
}

// ESC e clique fora chegam como `update:modelValue(false)` do v-dialog.
function onDialogUpdate(value: boolean) {
  if (!value) closeDialog()
}

function dismiss() {
  closeDialog()
}

function useUnidentified() {
  emit('useUnidentified')
  closeDialog()
}

const text = COLORS.text

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": _unref(isDesktop) ? 720 : undefined,
    fullscreen: !_unref(isDesktop),
    scrollable: "",
    attach: "#app",
    scrim: "rgba(22, 22, 29, 0.55)",
    "aria-labelledby": titleId,
    "data-testid": "placeholder-blocked-dialog",
    "onUpdate:modelValue": onDialogUpdate
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["placeholder-blocked", _unref(isDesktop) ? 'placeholder-blocked--desktop' : 'placeholder-blocked--mobile'])
      }, [
        _createElementVNode("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                _createElementVNode("path", {
                  d: _unref(mdiAlertOutline),
                  fill: "currentColor"
                }, null, 8, _hoisted_5)
              ]))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", {
                id: titleId,
                ref_key: "titleRef",
                ref: titleRef,
                tabindex: "-1",
                class: "placeholder-blocked__title",
                "data-testid": "placeholder-blocked-title"
              }, " Este médico não pode ser usado como coringa ", 512),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.doctorName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                        _createElementVNode("path", {
                          d: _unref(mdiAccountOutline),
                          fill: "currentColor"
                        }, null, 8, _hoisted_10)
                      ])),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.doctorName), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_12
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, [
              _createTextVNode(" Até agora, quando ainda não sabíamos quem faria o plantão, usávamos a Dra. Ana Lavradas no lugar. Isso misturava vagas abertas com plantões cobertos e bagunçava relatórios e pagamentos. Agora existe a opção "),
              _createElementVNode("strong", null, _toDisplayString(_unref(UNIDENTIFIED_COVERAGE_LABEL)), 1),
              _createTextVNode(": o plantão fica marcado como coberto, sem precisar indicar um médico. ")
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("ol", _hoisted_18, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step) => {
                return _createElementVNode("li", {
                  key: step.number,
                  class: "placeholder-blocked__step"
                }, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(step.number), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", {
                      class: "placeholder-blocked__step-text",
                      "data-testid": `placeholder-blocked-step-${step.number}-text`
                    }, _toDisplayString(step.text), 9, _hoisted_21),
                    _createElementVNode("div", {
                      role: "img",
                      "aria-label": step.illustrationLabel,
                      class: "placeholder-blocked__illustration",
                      "data-testid": `placeholder-blocked-illustration-${step.number}`
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        (step.number === 1)
                          ? (_openBlock(), _createBlock(CoverageModeSelector, {
                              key: 0,
                              "model-value": _unref(CoverageMode).UNIDENTIFIED,
                              "allow-unidentified": true,
                              label: COVERAGE_BLOCK_TITLE,
                              disabled: "",
                              class: "placeholder-blocked__selector"
                            }, null, 8, ["model-value"]))
                          : (step.number === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(COVERAGE_RESPONSIBLE_LABEL)), 1),
                                  _createElementVNode("span", _hoisted_27, [
                                    _createElementVNode("span", { class: "truncate" }, _toDisplayString(EXAMPLE_RESPONSIBLE)),
                                    (_openBlock(), _createElementBlock("svg", _hoisted_28, [
                                      _createElementVNode("path", {
                                        d: _unref(mdiMenuUp),
                                        fill: "currentColor"
                                      }, null, 8, _hoisted_29)
                                    ]))
                                  ])
                                ]),
                                _createElementVNode("ul", _hoisted_30, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(EXAMPLE_RESPONSIBLE_OPTIONS, (option) => {
                                    return _createElementVNode("li", {
                                      key: option,
                                      class: _normalizeClass({ 'placeholder-blocked__menu-item--active': option === EXAMPLE_RESPONSIBLE })
                                    }, _toDisplayString(option), 3)
                                  }), 64))
                                ])
                              ]))
                            : (step.number === 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(COVERAGE_NOTE_LABEL)), 1),
                                  _createElementVNode("span", { class: "block min-h-[2.5rem] break-words" }, _toDisplayString(EXAMPLE_NOTE))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createVNode(UnidentifiedRow, { "responsible-name": EXAMPLE_RESPONSIBLE })
                                ]))
                      ])
                    ], 8, _hoisted_22)
                  ])
                ])
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(), _createElementBlock("svg", _hoisted_35, [
                _createElementVNode("path", {
                  d: _unref(mdiInformationOutline),
                  fill: "currentColor"
                }, null, 8, _hoisted_36)
              ])),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("p", _hoisted_38, " Não aparece a opção '" + _toDisplayString(_unref(UNIDENTIFIED_COVERAGE_LABEL)) + "'? Peça para quem administra a escala ligar 'Permite plantão ocupado sem identificação' na configuração da escala. ", 1),
                _hoisted_39
              ])
            ])
          ])
        ]),
        _createElementVNode("footer", _hoisted_40, [
          _createVNode(OutlineButton, {
            height: "44px",
            width: _unref(isDesktop) ? '140px' : '100%',
            color: "grey",
            class: "placeholder-blocked__button",
            "data-testid": "placeholder-blocked-dismiss",
            onClick: dismiss
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Entendi ")
            ]),
            _: 1
          }, 8, ["width"]),
          (_ctx.allowUnidentified)
            ? (_openBlock(), _createBlock(FilledButton, {
                key: 0,
                height: "44px",
                width: _unref(isDesktop) ? 'auto' : '100%',
                color: "primary",
                class: "placeholder-blocked__button placeholder-blocked__button--primary",
                "data-testid": "placeholder-blocked-use-unidentified",
                onClick: useUnidentified
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", _hoisted_41, [
                    _createElementVNode("path", {
                      d: _unref(mdiCheckCircleOutline),
                      fill: "currentColor"
                    }, null, 8, _hoisted_42)
                  ])),
                  _createTextVNode(" Usar " + _toDisplayString(_unref(UNIDENTIFIED_COVERAGE_LABEL)), 1)
                ]),
                _: 1
              }, 8, ["width"]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["model-value", "max-width", "fullscreen"]))
}
}

})